/* import __COLOCATED_TEMPLATE__ from './projects-results-list.hbs'; */
import { readOnly } from '@ember/object/computed';
import { computed } from '@ember/object';
import { A } from '@ember/array';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { APPLICATION } from 'sh-www/models/application';
import { EMBER_ROUTE_NAMES } from "../../constants/routes";
import { PROJECTS_NETWORK_FILTER_OPTIONS } from "../../constants/routes/projects";

export default Component.extend({
  /**
   * HTML Component properties
   */
  tagName: 'ul',
  classNames: ['SH-c-projects-results-list'],
  classNameBindings: ['state.isEmptyDefaultSearch:margin-top-32px'],

  /**
   * Register services
   */
  state: service('states/routes/projects'),

  /**
   * Array of Assignment models to show results for.
   *
   * @param {Ember.MutableArray}
   */
  applicationListItems: A(),

  /**
   * True when we have at least 1 application summary
   *
   * @type {Boolean}
   * @private
   */
  _hasListItems: computed('applicationListItems.length', function() {
    return !!this.get('applicationListItems.length');
  }),

  /**
   * True if we have NOT searched yet.  Different than a search with no results.
   *
   * @type {Boolean}
   */
  _hasNotSearchedYet: readOnly('state.hasNotSearchedYet'),

  /**
   * True if we want to show loader
   *
   * @type {Boolean}
   * @private
   */
  _isShowSearchLoader: computed('state.isLoadingResult', 'applicationListItems', function() {
    return this.get('state.isLoadingResult') && !this.get('applicationListItems.length');
  }),

  /**
   * True when this is the 'cancelled' view
   *
   * @type {Boolean}
   * @private
   */
  _isCancelled: computed('state.currentApplicationViewStatus', function() {
    return this.get('state.currentApplicationViewStatus') === APPLICATION.SIMPLE_STATUS.CANCELLED_BUYER;
  }),

  /**
   * True when this is the 'completed' view
   *
   * @type {Boolean}
   * @private
   */
  _isCompleted: computed('state.currentApplicationViewStatus', function() {
    return this.get('state.currentApplicationViewStatus') === APPLICATION.SIMPLE_STATUS.COMPLETE;
  }),

  /**
   * True when this is the 'in progress' view
   *
   * @type {Boolean}
   * @private
   */
  _isInProgress: computed('state.currentApplicationViewStatus', function() {
    return this.get('state.currentApplicationViewStatus') === APPLICATION.SIMPLE_STATUS.IN_PROGRESS_BUYER;
  }),

  /**
   * True when the search component is activated
   *
   * @type {Boolean}
   * @private
   */
  _isSearchActivated: readOnly('state.isSearchActivated'),

  /**
   * True when we want to show a specific message for an empty user filter change. i.e. not the default filter
   *
   * @type {Boolean}
   */
  _isShowFilterSpecificEmptyMessage: computed('state.networkFilterSelectedValue', function() {
    return this.get('state.networkFilterSelectedValue') !== PROJECTS_NETWORK_FILTER_OPTIONS.POSTED_BY_ANYONE;
  }),

  _routePostings: EMBER_ROUTE_NAMES.POSTINGS__LIVE
});
